import { fetchPostUsers, fetchPostDocket } from "../../../faetures/fetch";

function insertNewUser (resolve, setNames, resetUser, dataUser, setMassage) {

    let text_to_massage = "";
    let allowed_to_massage = false;

    if (typeof resolve === 'object' && resolve !== null) {
        if (resolve[0] === 'okay') {
            let dataUpdate = {...dataUser};
            text_to_massage = 'שם הוסף בהצלחה';

            Object.entries(resolve['data']).map(([key, value]) => {
                dataUpdate[key] = {};

                if (typeof value !== 'object') {
                    text_to_massage += `\n שגיאה ${key} לא עודכן`;
                } else {
                    Object.entries(value).map(([keyId, valueId]) => {
                        dataUpdate[key][valueId] = {...dataUser[key][keyId]}
                    })
                }
            })

            setNames(resolve['user'], dataUpdate);
            resetUser();
        } else if (resolve[0] === 'exits') {
            text_to_massage = `שם כבר קיים במערכת\nלחץ על ביטול כדי להמשיך,   לחץ על אישור כדי לעבור לחיפוש`;
            allowed_to_massage = true;
        } else if (resolve[0] === 'error') {
            text_to_massage = 'אחד מהפרטים שגוים, שם לא עודכן במערכת';
        }
    }

    setMassage(text_to_massage || "שגיאה", allowed_to_massage);
}

function updateUser (resolve, newData, oldData, numOfUser, setOldUser, setUser, setMassage) {
    let text_for_massage = "";

    if (typeof resolve === 'object' && resolve !== null) {
        if (resolve['0'] === 'okay') {
            text_for_massage = 'שינוים עודכנו בהצלחה';

            Object.keys(resolve['data_other']).map((value) => {

                if (! (typeof resolve['data_other'][value] === 'object')) {
                    newData[value] = oldData[value];
                    text_for_massage += `\nשגיאה ${value} לא עודכן`
                } else {
                    Object.entries(resolve['data_other'][value]).map(([keyId, valueId]) => {
                        let v = newData[value][keyId];
                        delete newData[value][keyId];
                        newData[value][valueId] = v;
                    })
                }
            })

            setOldUser(numOfUser, newData);
            setUser(newData);

        } else if (resolve['0'] === 'invalid change name') {
            setUser(oldData);
            text_for_massage = 'אין הראשה לשינוי שם'
        } else {
            setUser(oldData);
            text_for_massage = 'אחד מהפרטים שגויים, שם לא עודכן';
        }
    }

    setMassage(text_for_massage);
}

function deleteNames ({num, numOfDocket, setMassage, deleteNames}) {
    setMassage('');
    
    fetchPostDocket('delete-names', {num: numOfDocket, names: [num]}).then((resolve) => {
        if (resolve === 'okay') {
            deleteNames([num]);
            setMassage({open: false, agree: false, confirmed: false, text: ''});
        } else {
            setMassage({open: true, agree: false, confirmed: false, text: 'שגיאה !'});
        }
    }).catch(() => {
        setMassage({open: true, agree: false, confirmed: false, text: 'שגיאה בשרת נסה יותר מאוחר'});
    })
}

function check_change (oldData, newData) {
    /* Checking for the changed data and sending only what has changed to the server. */
    const change = {data: {}};
    Object.entries(newData).map(([key, value]) => {
        if (!(value instanceof Object)) {
            if (value !== oldData[key]) {
                change.data[key] = value;
            }
        } else {
            if (JSON.stringify(value) !== JSON.stringify(oldData[key])) {
                change[key] = {n: {}, u: {}, d: []};
                let keysOld = Object.keys(oldData[key]);
                let keysNew = Object.keys(value);
                keysNew.map((key_new) => { // Checking for new entries
                    if (!keysOld.includes(key_new)) {
                        change[key]['n'][key_new] = value[key_new];
                    }})
                keysOld.map((key_old) => { // Checking for deletions.
                    if (!keysNew.includes(key_old)) {
                        change[key].d.push(key_old);
                    } else { // checking for updated
                        if (JSON.stringify(oldData[key][key_old]) !== JSON.stringify(value[key_old])) {
                            change[key]['u'][[key_old]] = value[key_old];
                        }
                    }
                
                })
            }
        }
    })
    return change;
}

export {insertNewUser, updateUser, deleteNames, check_change};
